const EnumYesNo = {
  YES: 1,
  NO: 2,
};

export default EnumYesNo;
